import styled from 'styled-components';

import HoverableElement from '../HoverableElement';
import Spinner from '../Spinner';

export const StyledContainer = styled.div`
  position: relative;
`;

interface TriggerContainerProps {
  fullWidth?: boolean;
}
// Applying inline-block ensures that the trigger container rect resembles the trigger, in case
// the trigger is less than 100% wide.
export const TriggerContainer = styled.div<TriggerContainerProps>`
  display: ${(props) => (props.fullWidth ? 'block' : 'inline-block')};
`;

export const StyledSpinner = styled(Spinner)`
  margin: 10px;
`;

export const HoverableElementFullWidth = styled(HoverableElement)`
  width: 100%;
`;
